import { configService } from "@/settings/api-url";
import store from "@/store/store";
const actions = {
  async action_getCountries({ commit }) {
    try {
      const res = await configService("/countries");
      const { data } = res;
      commit("COUNTRIES", data);
      return res;
    } catch (error) {
      return;
    }
  },
  async action_getCountry({ commit, getters }, id) {
    try {
      const country = id ? id : getters.getCountry.id;
      const res = await configService(`countries/${country}`);
      const { data } = res;
      commit("COUNTRY", data);
      commit("CITIES", data.cities);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getCountryNoSave({}, id = 2) {
    try {
      const res = await configService(`countries/${id}`);
      const { data } = res;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getCities({ commit, dispatch }) {
    try {
      const countries = store.getters.getCountries;
      let res = [];
      if (countries && countries.length) {
        for (let i = 0; i < countries.length; i++) {
          let countryDetail = await dispatch("action_getCountryNoSave", countries[i].id);
          if (countryDetail && countryDetail.data) {
            countryDetail = countryDetail.data;
          }
          if (countryDetail && countryDetail.cities) {
            for (let j = 0; j < countryDetail.cities.length; j++) {
              const currentCity = countryDetail.cities[j];
              res.push({
                id: currentCity.id,
                country_code: countryDetail.country_code,
                country_id: countryDetail.id,
                ...currentCity,
              });
            }
          }
        }
      }
      commit("CITIES", res);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
